import emailjs from "@emailjs/browser"

const SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID
const WELCOME_TEMPLATE_ID = import.meta.env.VITE_EMAILJS_WELCOME_TEMPLATE_ID
const INVITE_TEMPLATE_ID = import.meta.env.VITE_EMAILJS_INVITE_TEMPLATE_ID
const PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY

// Sends the custom "Welcome to Nesolearn" email with the organization's
// Nesolearn ID and profile details. Separate from Firebase's built-in
// verification email, which has its own fixed template.
export const sendOrgWelcomeEmail = async ({ toEmail, ownerName, orgName, orgId }) => {
  if (!SERVICE_ID || !WELCOME_TEMPLATE_ID || !PUBLIC_KEY) {
    console.warn("EmailJS is not configured — skipping welcome email")
    return { error: null }
  }

  try {
    await emailjs.send(
      SERVICE_ID,
      WELCOME_TEMPLATE_ID,
      {
        to_email: toEmail,
        owner_name: ownerName,
        org_name: orgName,
        org_id: `NESO-${orgId}`,
      },
      { publicKey: PUBLIC_KEY }
    )
return { error: null }
  } catch (error) {
    return { error }
  }
}

// Sends a learner invite email. Unlike the team invite (which matches by email
// on next login), this carries a specific invite link with an invitation ID —
// acceptance happens via acceptInvitation() reading that ID from the URL.
const LEARNER_INVITE_TEMPLATE_ID = import.meta.env.VITE_EMAILJS_LEARNER_INVITE_TEMPLATE_ID

export const sendLearnerInviteEmail = async ({ toEmail, orgName, invitedByName, courseTitle, inviteLink }) => {
  if (!SERVICE_ID || !LEARNER_INVITE_TEMPLATE_ID || !PUBLIC_KEY) {
    console.warn("EmailJS learner invite template is not configured â€” skipping email (link is still usable)")
    return { error: null }
  }
  try {
    await emailjs.send(
      SERVICE_ID,
      LEARNER_INVITE_TEMPLATE_ID,
      {
        to_email: toEmail,
        org_name: orgName,
        invited_by: invitedByName,
        course_title: courseTitle,
        invite_link: inviteLink,
      },
      { publicKey: PUBLIC_KEY }
    )
    return { error: null }
  } catch (error) {
    return { error }
  }
}

// Sends a team invite email. The invitee accepts by simply signing up or logging in
// with the same email address â€” linkPendingInvitesForUser() handles the rest.
export const sendTeamInviteEmail = async ({ toEmail, orgName, invitedByName, role }) => {
  if (!SERVICE_ID || !INVITE_TEMPLATE_ID || !PUBLIC_KEY) {
    console.warn("EmailJS is not configured — skipping invite email")
    return { error: null }
  }

  try {
    await emailjs.send(
      SERVICE_ID,
      INVITE_TEMPLATE_ID,
      {
        to_email: toEmail,
        org_name: orgName,
        invited_by: invitedByName,
        role,
        signup_link: `${window.location.origin}/authentication-portal`,
      },
      { publicKey: PUBLIC_KEY }
    )
    return { error: null }
  } catch (error) {
    return { error }
  }
}